const PaymentRateInterval = {
    Weekly: 9999,
    Monthly: 99999
};

export default PaymentRateInterval;
